import React from 'react';
import { _route } from '../../utils';
import { makeStyles } from '@material-ui/core';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useSelector } from 'react-redux';
import { ArrowForward as ArrowForwardIcon } from '@material-ui/icons';

const useStyles = makeStyles({
  containerWarning: {
    background: '#FFFCF5',
    borderWidth: '0px 1px 2px 1px',
    borderStyle: 'solid',
    borderColor: '#FEC84B',
    padding: '12px 35px 14px 35px',
    display: 'flex',
    justifyContent: 'center',
  },
  warningText: {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    color: '#B54708',
    marginLeft: '8px',
    display: 'flex',
    alignItems: 'center',
  },
  ArrowForward: {
    verticalAlign: 'middle',
    width: '18px',
    fill: '#1e38ea',
  },
});

function WarningHeaderWidget({ warningMessage, connectButton }) {
  const classes = useStyles();
  const { realm } = useSelector(({ auth }) => auth);

  return (
    <div className={classes.containerWarning}>
      <div>
        <div className="flexAlignCenter">
          <InfoOutlinedIcon style={{ color: '#B54708', fontSize: '20px' }} />
          <div className={classes.warningText}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {warningMessage}
              {connectButton === 'true' && (
                <a
                  href={_route('store.storeReconnect', { realm })}
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginLeft: '2px',
                    gap: '2px',
                    color: '#1e38ea',
                  }}
                >
                  Reconnect Now
                  <ArrowForwardIcon className={classes.ArrowForward} />
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WarningHeaderWidget;
